import validate from '@/utils/validations/cnpj'

export default {
    validate,
    message: 'O CNPJ informado é inválido.',
}